"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearDdl = exports.hidePopUp = exports.showPopUp = exports.LogDimensions = exports.InfoImageClick = exports.CheckSessionTimeout = exports.ErrorHandler = exports.ShortMonth = exports.ShortDay = exports.AddDatepicker = exports.getItemDescription = exports.OnErrorCallWebService = exports.tbGenericOnblur = exports.AddItemASPDropdown = exports.AddItemGeneric = exports.fillDropDownGeneric = exports.FilterGeneric = exports.FilterAndFillGeneric = exports.CallWebServiceGetGenericDataSyncUsingGet = exports.CallWebServiceGetGenericDataSync = exports.CallWebServiceGetGenericSync = exports.CallWebServiceGetGenericData = exports.CallWebServiceGetGeneric = exports.validateEmail = exports.Translate = exports.SetRowBackcolor = exports.GetTrClass = exports.Validate = exports.TabToNextField = exports.KeyDown = exports.DisableEnterKey = exports.ClickOutside = exports.PopupControl = void 0;
var Logging = require("./Logging");
//(function (e) { e.fn.hoverIntent = function (t, n, r) { var i = { interval: 100, sensitivity: 7, timeout: 0 }; if (typeof t === "object") { i = e.extend(i, t) } else if (e.isFunction(n)) { i = e.extend(i, { over: t, out: n, selector: r }) } else { i = e.extend(i, { over: t, out: t, selector: n }) } var s, o, u, a; var f = function (e) { s = e.pageX; o = e.pageY }; var l = function (t, n) { n.hoverIntent_t = clearTimeout(n.hoverIntent_t); if (Math.abs(u - s) + Math.abs(a - o) < i.sensitivity) { e(n).off("mousemove.hoverIntent", f); n.hoverIntent_s = 1; return i.over.apply(n, [t]) } else { u = s; a = o; n.hoverIntent_t = setTimeout(function () { l(t, n) }, i.interval) } }; var c = function (e, t) { t.hoverIntent_t = clearTimeout(t.hoverIntent_t); t.hoverIntent_s = 0; return i.out.apply(t, [e]) }; var h = function (t) { var n = jQuery.extend({}, t); var r = this; if (r.hoverIntent_t) { r.hoverIntent_t = clearTimeout(r.hoverIntent_t) } if (t.type == "mouseenter") { u = n.pageX; a = n.pageY; e(r).on("mousemove.hoverIntent", f); if (r.hoverIntent_s != 1) { r.hoverIntent_t = setTimeout(function () { l(n, r) }, i.interval) } } else { e(r).off("mousemove.hoverIntent", f); if (r.hoverIntent_s == 1) { r.hoverIntent_t = setTimeout(function () { c(n, r) }, i.timeout) } } }; return this.on({ "mouseenter.hoverIntent": h, "mouseleave.hoverIntent": h }, i.selector) } })(jQuery)
function PopupControl($tb, $pnl) {
    $pnl.css('visibility', 'hidden');
    $pnl.css('left', $tb.position().left);
    $pnl.css('top', $tb.position().top + $tb.outerHeight());
    $tb.click(function () {
        $pnl.css('visibility', 'visible');
        ClickOutside($pnl);
    });
}
exports.PopupControl = PopupControl;
function ClickOutside($obj) {
    $(document).mouseup(function (e) {
        if (!$obj.is(e.target) // if the target of the click isn't the container...
            && $obj.has(e.target).length === 0) // ... nor a descendant of the container
         {
            $obj.css('visibility', 'hidden');
        }
    });
}
exports.ClickOutside = ClickOutside;
function DisableEnterKey($tb) {
    $tb.keydown(function (e) {
        switch (e.which) {
            case 13: //Enter
                TabToNextField($tb);
                e.preventDefault();
                break;
        }
    });
}
exports.DisableEnterKey = DisableEnterKey;
function KeyDown(e, _self) {
    switch (e.which) {
        case 13: //Enter
            e.preventDefault();
            _self.DisableKeyUp = true;
            if (_self.$pnl.css('visibility') == 'visible') {
                var ItemInFocus = _self.$pnl.find('.' + _self.classItemInFocus);
                if (ItemInFocus.length == 0) {
                    if (_self.$tb.val() == '') {
                        TabToNextField(_self.$tb);
                    }
                    else {
                        var Items = _self.$pnl.find('.' + _self.classItem);
                        if (Items.size() == 0) {
                            TabToNextField(_self.$tb);
                        }
                        else {
                            _self.$tb.val($(Items[0]).text());
                            TabToNextField(_self.$tb);
                        }
                    }
                }
                else {
                    _self.$tb.val(ItemInFocus.text());
                    TabToNextField(_self.$tb);
                }
            }
            else {
                TabToNextField(_self.$tb);
            }
            _self.hidePopup();
            break;
        case 38: //Arrow up
            _self.DisableKeyUp = true;
            var itemInFocus = _self.$pnl.find('.' + _self.classItemInFocus);
            if (itemInFocus.length) {
                var itemBeforeItemInFocus = itemInFocus.prevAll('.' + _self.classItem + ':first');
                if (itemBeforeItemInFocus.length) {
                    itemInFocus.removeClass(_self.classItemInFocus);
                    itemBeforeItemInFocus.addClass(_self.classItemInFocus);
                    var scrollTopPnl = _self.$pnl.scrollTop();
                    var offsetFirstItem = _self.$pnl.find('.' + _self.classItem).first().offset().top;
                    var offsetItemInFocus = itemBeforeItemInFocus.offset().top;
                    var offsetFromTop = offsetItemInFocus - offsetFirstItem;
                    if (offsetFromTop < scrollTopPnl) {
                        _self.$pnl.animate({ scrollTop: offsetFromTop }, 10);
                    }
                }
            }
            break;
        case 40: //Arrow down
            _self.DisableKeyUp = true;
            if (_self.$pnl.css('visibility') == 'visible') {
                var itemInFocus = _self.$pnl.find('.' + _self.classItemInFocus);
                if (itemInFocus.length) {
                    var itemAfterItemInFocus = itemInFocus.nextAll('.' + _self.classItem + ':first');
                    if (itemAfterItemInFocus.length) {
                        itemInFocus.removeClass(_self.classItemInFocus);
                        itemAfterItemInFocus.addClass(_self.classItemInFocus);
                        var offsetItemInFocus = itemAfterItemInFocus.offset().top;
                        var offsetFirstItem = _self.$pnl.find('.' + _self.classItem).first().offset().top;
                        var offsetFromTop = offsetItemInFocus - offsetFirstItem;
                        var offset = offsetFromTop - _self.$pnl.height() + 20;
                        //log('offsetItemInFocus:' + offsetItemInFocus + '|offsetFirstItem:' + offsetFirstItem + '|offsetFromTop:' + offsetFromTop + '|offset:' + offset + '|_self.$pnl.scrollTop:' + _self.$pnl.scrollTop());
                        if (offset > _self.$pnl.scrollTop()) {
                            _self.$pnl.animate({ scrollTop: offset }, 10);
                        }
                    }
                }
                else {
                    _self.$pnl.find('.' + _self.classItem).first().addClass(_self.classItemInFocus);
                }
            }
            else {
                _self.showPopup();
                if (_self.$pnl.find('.' + _self.classItemInFocus).length == 0) {
                    _self.$pnl.find('.' + _self.classItemInFocus).removeClass(_self.classItemInFocus);
                    _self.$pnl.find('.' + _self.classItem).first().addClass(_self.classItemInFocus);
                }
            }
            break;
        default:
            _self.DisableKeyUp = false;
    }
}
exports.KeyDown = KeyDown;
function TabToNextField($tb) {
    var inputs = $tb.closest('form').find(':input');
    inputs.eq(inputs.index($tb) + 1).focus();
}
exports.TabToNextField = TabToNextField;
function Validate($tab) {
    var errors = false;
    $tab.find('.RequiredField').each(function () {
        if ($(this).val() == '') {
            $(this).addClass('FieldInError');
            errors = true;
        }
        else {
            $(this).removeClass('FieldInError');
        }
        ;
    });
    return (!errors);
}
exports.Validate = Validate;
function GetTrClass(i) {
    if ((i % 2) == 0) {
        return 'trItemBackcolor';
    }
    else {
        return 'trItemBackcolorAlternating';
    }
}
exports.GetTrClass = GetTrClass;
function SetRowBackcolor($table) {
    var $rows = $('#' + $table[0].id + ' > tbody > tr:has(td)');
    for (var i = 0; i < $rows.length; i++) {
        var $row = $($rows[i]);
        $row.removeClass('trItemBackcolor');
        $row.removeClass('trItemBackcolorAlternating');
        if ((i % 2) == 0) {
            $row.addClass('trItemBackcolor');
        }
        else {
            $row.addClass('trItemBackcolorAlternating');
        }
    }
}
exports.SetRowBackcolor = SetRowBackcolor;
function Translate(Mnemonic) {
    var $hf = $('#ctl00_cphBody_HF' + Mnemonic);
    if ($hf == undefined) {
        return Mnemonic;
    }
    else {
        return $hf.val();
    }
}
exports.Translate = Translate;
function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
exports.validateEmail = validateEmail;
//GET DATA
function CallWebServiceGetGeneric(functionName, OnSuccessGetFunction) {
    CallWebServiceGetGenericData(functionName, "{}", OnSuccessGetFunction);
}
exports.CallWebServiceGetGeneric = CallWebServiceGetGeneric;
function CallWebServiceGetGenericData(functionName, Data, OnSuccessGetFunction) {
    $.ajax({
        type: "POST",
        url: "Aanvraag.asmx/" + functionName,
        data: Data,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: OnSuccessGetFunction,
        error: OnErrorCallWebService
    });
}
exports.CallWebServiceGetGenericData = CallWebServiceGetGenericData;
function CallWebServiceGetGenericSync(functionName) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, CallWebServiceGetGenericDataSync(functionName, "{}")];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
exports.CallWebServiceGetGenericSync = CallWebServiceGetGenericSync;
function CallWebServiceGetGenericDataSync(functionName, Data) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, $.ajax({
                        type: "POST",
                        url: "Aanvraag.asmx/" + functionName,
                        data: Data,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        //async: false,
                        //success: OnSuccessGetFunction,
                        error: OnErrorCallWebService
                    })];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
exports.CallWebServiceGetGenericDataSync = CallWebServiceGetGenericDataSync;
function CallWebServiceGetGenericDataSyncUsingGet(functionName, Data) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, $.ajax({
                        type: "GET",
                        url: encodeURI("Aanvraag.asmx/" + functionName + "?" + Data),
                        //data: Data,
                        contentType: "application/xml; charset=utf-8",
                        dataType: "json",
                        //async: false,
                        //success: OnSuccessGetFunction,
                        error: OnErrorCallWebService
                    })];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
exports.CallWebServiceGetGenericDataSyncUsingGet = CallWebServiceGetGenericDataSyncUsingGet;
//FILTER DATA
function FilterAndFillGeneric(cb, ItemsAll) {
    var Items = FilterGeneric(cb.$tb.val(), ItemsAll);
    if (Items.length == 0) {
        cb.$pnl.css('visibility', 'hidden');
    }
    else {
        cb.$pnl.css('visibility', 'visible');
    }
    fillDropDownGeneric(cb, Items);
}
exports.FilterAndFillGeneric = FilterAndFillGeneric;
function FilterGeneric(filter, ItemsAll) {
    var filteredItems = new Array();
    for (var i = 0; i < ItemsAll.length; i++) {
        var Item = ItemsAll[i];
        if (Item.Description.toLowerCase().indexOf(filter.toLowerCase()) != -1) {
            filteredItems.push(Item);
        }
    }
    return filteredItems;
}
exports.FilterGeneric = FilterGeneric;
//DROPDOWN
function fillDropDownGeneric(cb, Items) {
    cb.$pnl.empty();
    for (var i = 0; i < Items.length; i++) {
        AddItemGeneric(cb, Items[i]);
    }
}
exports.fillDropDownGeneric = fillDropDownGeneric;
function AddItemGeneric(cb, Item) {
    var $div = $('<div class="divDropDownItem">' + Item.Description + '</div>');
    $div.click(function (e) { cb.pnlOnClick(Item.Code, Item.Description); });
    $div.mouseover(function () { cb.pnlOnMouseover(this); });
    cb.$pnl.append($div);
}
exports.AddItemGeneric = AddItemGeneric;
function AddItemASPDropdown(dropdown, code, description, selected) {
    var option = document.createElement("OPTION");
    option.innerHTML = description;
    option.value = code;
    if (selected)
        option.setAttribute("selected", "selected");
    dropdown[0].options.add(option);
}
exports.AddItemASPDropdown = AddItemASPDropdown;
//EVENTS
function tbGenericOnblur(tbValue, ItemsAll) {
    for (var i = 0; i < ItemsAll.length; i++) {
        var Item = ItemsAll[i];
        if (Item.Description.toLowerCase() == tbValue.toLowerCase()) {
            return Item;
        }
    }
    return '';
}
exports.tbGenericOnblur = tbGenericOnblur;
function OnErrorCallWebService(request, status, error) {
    Logging.log(error);
}
exports.OnErrorCallWebService = OnErrorCallWebService;
function getItemDescription(Items, Code) {
    for (var i = 0; i < Items.length; i++) {
        var Item = Items[i];
        if (Item.Code == Code) {
            return Item.Description;
        }
    }
}
exports.getItemDescription = getItemDescription;
function AddDatepicker($tb, minDate, maxDate) {
    $tb.datepicker({
        dateFormat: "dd-mm-yy",
        dayNames: [Translate("nmZondag"), Translate("nmMaandag"), Translate("nmDinsdag"), Translate("nmWoensdag"), Translate("nmDonderdag"), Translate("nmVrijdag"), Translate("nmZaterdag")],
        dayNamesMin: [ShortDay("nmZondag"), ShortDay("nmMaandag"), ShortDay("nmDinsdag"), ShortDay("nmWoensdag"), ShortDay("nmDonderdag"), ShortDay("nmVrijdag"), ShortDay("nmZaterdag")],
        firstDay: 1,
        monthNames: [Translate("nmJanuari"), Translate("nmFebruari"), Translate("nmMaart"), Translate("nmApril"), Translate("nmMei"), Translate("nmJuni"), Translate("nmJuli"), Translate("nmAugustus"), Translate("nmSeptember"), Translate("nmOktober"), Translate("nmNovember"), Translate("nmDecember")],
        monthNamesShort: [ShortMonth("nmJanuari"), ShortMonth("nmFebruari"), ShortMonth("nmMaart"), ShortMonth("nmApril"), ShortMonth("nmMei"), ShortMonth("nmJuni"), ShortMonth("nmJuli"), ShortMonth("nmAugustus"), ShortMonth("nmSeptember"), ShortMonth("nmOktober"), ShortMonth("nmNovember"), ShortMonth("nmDecember")],
        beforeShow: function (input, inst) {
            $('#ui-datepicker-div').addClass("notranslate");
        },
        minDate: minDate,
        maxDate: maxDate
    });
}
exports.AddDatepicker = AddDatepicker;
function ShortDay(value) {
    return Translate(value).substring(0, 2);
}
exports.ShortDay = ShortDay;
function ShortMonth(value) {
    return Translate(value).substring(0, 3);
}
exports.ShortMonth = ShortMonth;
function ErrorHandler(err) {
    Logging.log(err.message);
}
exports.ErrorHandler = ErrorHandler;
function CheckSessionTimeout(data) {
    if (data.d == null) {
        debugger;
        location.reload();
    }
}
exports.CheckSessionTimeout = CheckSessionTimeout;
function InfoImageClick(img, $pnl, $dialog) {
    var $img = $(img);
    $pnl.css('left', $img.offset().left + $img.outerWidth());
    $pnl.css('top', $dialog.offset().top - 205);
    $pnl.css('visibility', 'visible');
    ClickOutside($pnl);
}
exports.InfoImageClick = InfoImageClick;
function LogDimensions($obj, name) {
    Logging.log(name + '.offset() left:' + $obj.offset().left + ' top:' + $obj.offset().top);
    Logging.log(name + '.position() left:' + $obj.position().left + ' top:' + $obj.position().top);
    //log(name + '.size():' + $obj.size());
}
exports.LogDimensions = LogDimensions;
function showPopUp(pControl, text, event) {
    var control = $('#' + pControl);
    var div = $("<div id='" + pControl + "popup" + "'></div>");
    div.html(text);
    div.show()
        .css('top', event.pageY + 10)
        .css('left', event.pageX + 10)
        .css('position', 'absolute')
        .appendTo('body')
        .addClass('divPopUp');
    var pos = div.position();
    if (pos.left + div.width() > $('body').width()) {
        div.css('left', event.pageX - div.width());
        div.css('top', event.pageY + 20);
    }
}
exports.showPopUp = showPopUp;
function hidePopUp(pControl, event) {
    var control = $('#' + pControl + 'popup');
    control.remove();
}
exports.hidePopUp = hidePopUp;
function clearDdl(pControl) {
    pControl
        .find('option')
        .remove();
}
exports.clearDdl = clearDdl;
